import React, { Component } from 'react';
import { connect } from 'react-redux';
import Datetime from 'react-datetime';
import Moment from 'moment';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import Form from '../../components/react-validation/components/form';
import Input from '../../components/react-validation/components/input';
import Submit from '../../components/react-validation/components/submit';
import Textarea from '../../components/react-validation/components/text-area';
import * as Vali from '../../helper/validator-helper';
import PropTypes from 'prop-types';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import PubSub from '../../services/pubsub-service';
import * as PubSubActionType from '../../constants/pubus-action-type';
import * as CommonActionType from '../../constants/common-action-type';
import * as LotActionType from '../constants';
// import * as ProjectActionType from 'Projects/constants';
import TableList from 'components/TableList';
import Translate from 'components/translate';

const defaultParams = {
  defaultSortName: 'phaseName',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};
class AddIndividualLot extends Component {

  static propTypes = {
    match: PropTypes.object,
    ErrorMsg: PropTypes.array,
    dispatch: PropTypes.func,
    history: PropTypes.object,
    SelectListPhases: PropTypes.any,
    SelectListModels: PropTypes.any,
    SelectListInsurances: PropTypes.any,
    SelectListCostCodes: PropTypes.any,
    ManageLots: PropTypes.object,
    projectId: PropTypes.string
  }

  constructor(props) {
    super(props);

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: props.ManageLots.params.skip,
      sizePerPage: props.ManageLots.params.take,
      totalRecord: props.ManageLots.params.totalRecord,

      projectName: '',
      errorMsg: '',
      phase: null,
      costCode: null,
      plan: null,
      COE: null,
      currentLocationSearch: props.history.location.search,
      dateError: null
    };

    this.projectId = this.props.match.params.projectId ? this.props.match.params.projectId.replace('&', '') : this.props.projectId;

    this.isNew = this.props.match.params.isNew === 'true';

    var me = this;

    PubSub.subscribe(PubSubActionType.PUBLISH_PROJECT_INFORMATION, (msg, data) => {
      me.setState({ projectName: data.project.name });
    });
  }

  componentDidMount() {

    this.binding(this.objToParams(this.props.ManageLots.params));

    this.props.dispatch({
      type: CommonActionType.COMMON_SELECT_LIST_PHASE_BY_PROJECT_ID_ASYNC,
      params: {
        param: { projectId: this.projectId, searchKey: '', selectedValue: '' },
        nextAction: [{ action: CommonActionType.COMMON_SELECT_LIST_PHASE_SUCCESS, params: null }]
      }
    });

    this.props.dispatch({
      type: CommonActionType.COMMON_SELECT_LIST_MODEL_BY_PROJECT_ID_ASYNC,
      params: {
        param: { projectId: this.projectId, searchKey: '', selectedValue: '' },
        nextAction: [{ action: CommonActionType.COMMON_SELECT_LIST_MODEL_SUCCESS, params: null }]
      }
    });

    this.props.dispatch({
      type: CommonActionType.COMMON_SELECT_LIST_INSURANCE_ASYNC,
      params: {
        param: { searchKey: '', selectedValue: '' },
        nextAction: [{ action: CommonActionType.COMMON_SELECT_LIST_INSURANCE_SUCCESS, params: null }]
      }
    });

    this.props.dispatch({
      type: LotActionType.GET_LIST_COST_CODE_ASYNC,
      params: {projectId: this.projectId}
    });
  }

  componentWillReceiveProps(nextProps) {
    const { ManageLots, history } = nextProps;

    if (nextProps.ErrorMsg.length > 0) {
      this.form.showError(this.refs['name'], nextProps.ErrorMsg[0]);
    } else {
      this.form.resetForm(this.refs);
      // this.COE.reset();
    }

    if (ManageLots) {
      this.setState({
        totalRecord: ManageLots.params.totalRecord,
        data: ManageLots.items,
        status: ManageLots.params.status,
        currentPage: ManageLots.params.skip
      });
    }

    if (history.location.search.length && history.location.search !== this.state.currentLocationSearch) {
      this.setState({currentLocationSearch: history.location.search});
      if (history.location.search.indexOf('active=lots') > -1) {
        this.props.dispatch({
          type: CommonActionType.COMMON_SELECT_LIST_PHASE_BY_PROJECT_ID_ASYNC,
          params: {
            param: { projectId: this.projectId, searchKey: '', selectedValue: '' },
            nextAction: [{ action: CommonActionType.COMMON_SELECT_LIST_PHASE_SUCCESS, params: null }]
          }
        });

        this.props.dispatch({
          type: CommonActionType.COMMON_SELECT_LIST_MODEL_BY_PROJECT_ID_ASYNC,
          params: {
            param: { projectId: this.projectId, searchKey: '', selectedValue: '' },
            nextAction: [{ action: CommonActionType.COMMON_SELECT_LIST_MODEL_SUCCESS, params: null }]
          }
        });
      }
    }
  }

  componentWillUnmount() {
    // this.props.dispatch({
    //   type: LotActionType.RESET_LOT,
    //   params: null
    // });

    // this.props.dispatch({
    //   type: ProjectActionType.RESET_PROJECT,
    //   params: null
    // });
  }

  binding(params) {

    this.props.dispatch({
      type: LotActionType.GET_LOT_TAB_ASYNC,
      params: params
    });
  }

  objToParams(obj) {
    return {
      projectId: this.projectId,
      searchKey: '',
      sortField: defaultParams.defaultSortName,
      sortOrder: obj.sort.order,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  onTableBinding(configTable) {
    this.binding({
      ...this.objToParams(this.props.ManageLots.params),
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
  }

  onChangeCOE = (COE) => {
    if (typeof (COE) === 'string') {
      this.setState({ COE });
      if (Moment(COE, 'MM/DD/YYYY', true).isValid() || COE === '') {
        this.setState({dateError: null});
      } else {
        this.setState({dateError: 'Invalid datetime.'});
      }
    } else {
      this.setState({ COE: Moment(COE).format('MM/DD/YYYY') });
      if (Moment(COE, 'MM/DD/YYYY', true).isValid() || COE === '') {
        this.setState({dateError: null});
      } else {
        this.setState({dateError: 'Invalid datetime.'});
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.state.phase && this.state.plan) {
      let param = this.form.getValues();

      param['COE'] = null;
      if (this.state.COE) {
        if (Moment.isMoment(this.state.COE)) {
          param['COE'] = formatTimezoneDateTime(this.state.COE);
        } else {
          param['COE'] = formatTimezoneDateTime(Moment(this.state.COE));
        }
      }

      param['phaseId'] = this.state.phase.value;

      param['modelId'] = this.state.plan.value;

      param['insurancePolicyId'] = this.state.insurance ? this.state.insurance.value : null;

      param['projectCode'] = this.state.costCode ? this.state.costCode.value : null;

      this.props.dispatch({
        type: LotActionType.CREATE_LOT_ASYNC,
        params: {
          data: param,
          search: this.objToParams(this.props.ManageLots.params)
        },
        callback: () => {
          this.props.dispatch({
            type: LotActionType.GET_LOT_TAB_ASYNC,
            params: this.objToParams(this.props.ManageLots.params)
          });
          this.setState({COE: null});
        }
      });

    } else {
      this.setState({ errorMsg: 'Please setup model and phase before create lot.' });
    }
  }

  refreshList(params) {
    this.setState({
      defaultSortName: params.defaultSortName,
      defaultSortOrder: params.defaultSortOrder,
      sizePerPage: params.sizePerPage
    }, () => {
      this.props.dispatch({
        type: LotActionType.GET_LOT_TAB_ASYNC,
        params: {
          searchKey: '',
          projectId: this.projectId,
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder,
          skip: params.currentPage - 1,
          take: params.sizePerPage
        }
      });
    }
    );
  }

  render() {

    const data = this.props.ManageLots.items;

    const column = [
      { field: 'id', header: 'id', hidden: true, isKey: true, sort: false, dataAlign: 'left', headerAlign: 'left' },
      { field: 'phaseName', header: <Translate translateKey='phase' capitalize />, hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' },
      { field: 'name', header: <span><Translate translateKey='lot' capitalize /> number</span>, hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' },
      { field: 'streetAddress', header: 'Street Address', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' },
      { field: 'modelName', header: 'Plan', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' }
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord
    };

    return <div>
      <div className='box-form-siteone'>
        <div className='box-form-body'>
          <div className='block lotContent'>
            <div className='tab-content'>
              <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
                <span className='cls-danger help-block'>{this.state.errorMsg}</span>
                <Input type='hidden' name='projectId' ref='projectId' value={this.projectId} />
                <div className='row'>
                  <div className='col-md-6 col-sm-6 col-lg-6'>
                    <div className='form-group'>
                      <div className='row'>
                        <label className='col-md-3'><Translate translateKey='phase' capitalize /> <span className='text-danger'>*</span></label>
                        <Dropdown
                          onChange={ref => { this.onSelectChange(ref, 'phase'); }}
                          className='filestring-dropdown filter-dropdown'
                          options={this.props.SelectListPhases}
                          optionLabel='text'
                          value={this.state.phase}
                          placeholder='-- Please select'
                          style={{ display: 'inline-block', width: '60%', margin: 0 }} />
                      </div>
                    </div>
                    <div className='form-group'>
                      <div className='row'>
                        <label className='col-md-3'>Plan <span className='text-danger'>*</span></label>
                        <Dropdown
                          onChange={ref => { this.onSelectChange(ref, 'plan'); }}
                          className='filestring-dropdown filter-dropdown'
                          options={this.props.SelectListModels}
                          optionLabel='text'
                          value={this.state.plan}
                          placeholder='-- Please select'
                          style={{ display: 'inline-block', width: '60%', margin: 0 }} />
                      </div>
                    </div>
                    <div className='form-group'>
                      <div className='row'>
                        <label className='col-md-3'>Insurance policy</label>
                        <Dropdown
                          onChange={ref => { this.onSelectChange(ref, 'insurance'); }}
                          className='filestring-dropdown filter-dropdown'
                          options={this.props.SelectListInsurances}
                          optionLabel='text'
                          value={this.state.insurance}
                          placeholder='-- Please select'
                          showClear={true}
                          style={{ display: 'inline-block', width: '60%', margin: 0 }} />
                      </div>
                    </div>
                    <div className='form-group'>
                      <div className='row'>
                        <label className='col-md-3'>Cost center/account</label>
                        <Dropdown
                          onChange={ref => { this.onSelectChange(ref, 'costCode'); }}
                          className='filestring-dropdown filter-dropdown'
                          options={this.props.SelectListCostCodes}
                          optionLabel='text'
                          value={this.state.costCode}
                          showClear={true}
                          placeholder='-- Please select'
                          style={{ display: 'inline-block', width: '60%', margin: 0 }} />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6 col-sm-6 col-lg-6'>
                    <div className='form-group'>
                      <div className='row'>
                        <label className='col-md-3'><Translate translateKey='lot' capitalize /> number <span className='text-danger'>*</span></label>
                        <div className='col-md-7'>
                          <Input type='text'
                            name='name'
                            ref='name'
                            placeholder='Lot number'
                            className='form-control'
                            max='100'
                            maxLength='100'
                            validations={[Vali.required, Vali.maxlength]} />
                        </div>
                      </div>
                    </div>

                    <div className='form-group'>
                      <div className='row'>
                        <label className='col-md-3'>Street address <span className='text-danger'>*</span></label>
                        <div className='col-md-7'>
                          <Input type='text'
                            name='streetAddress'
                            ref='streetAddress'
                            placeholder='Street address'
                            className='form-control'
                            max='200'
                            maxLength='200'
                            validations={[Vali.required, Vali.maxlength]} />
                        </div>
                      </div>
                    </div>
                    <div className='form-group'>
                      <div className='row'>
                        <label className='col-md-3'>COE</label>
                        <Datetime
                          ref={ref => { this.COE = ref; }}
                          inputProps={{ placeholder: 'mm/dd/yyyy' }}
                          timeFormat={false}
                          className='col-md-7'
                          value={this.state.COE}
                          onChange={COE => this.onChangeCOE(COE)}
                          closeOnSelect={true} />
                        {this.state.dateError &&
                          <span
                            className='text-danger col-sm-9 col-sm-offset-3'
                            style={{fontSize: 12, marginTop: 5}}>{this.state.dateError}</span>
                        }
                      </div>
                    </div>
                    <div className='form-group'>
                      <div className='row'>

                        <label className='col-md-3'>Note</label>
                        <div className='col-md-7'>
                          <Textarea name='note'
                            ref='note'
                            placeholder='Note'
                            className='form-control'
                            max='200'
                            maxLength='200'
                            row='8'
                            validations={[Vali.maxlength]} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='center-buttons' style={{ 'marginBottom': '0' }}>
                  <Submit className='btn btn-primary btn-submit btn-siteone' disabled={this.state.dateError}>Add</Submit>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <div className='form-group' style={{'marginTop': '30px'}}>
        <h5 className='margin-bottom-15' style={{'fontWeight': 500}}><Translate translateKey='lot' capitalize plurals /> ({this.state.totalRecord})</h5>
        <TableList
          column={column}
          defaultParams={defaultParams}
          data={data}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
        />
      </div>
    </div>;
  }
}

const mapStateToProps = (state) => {
  return state.LotStore;
};

export default connect(mapStateToProps)(AddIndividualLot);



// WEBPACK FOOTER //
// ./src/Lots/Containers/add-individual-lot.js